// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.JvG76GpEJLUizr4N {
  padding: 24px;
}
.RJ6OGlxvjUsfHzbe {
  margin-bottom: 16px;
}
`, "",{"version":3,"sources":["webpack://./app/assets/pages/myPermissions/index.modules.less"],"names":[],"mappings":"AAAA;EACE,aAAA;AACF;AAEA;EACE,mBAAA;AAAF","sourcesContent":[".page {\n  padding: 24px;\n}\n\n.notice {\n  margin-bottom: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page": `JvG76GpEJLUizr4N`,
	"notice": `RJ6OGlxvjUsfHzbe`
};
export default ___CSS_LOADER_EXPORT___;
